export const SELECT_OPTION_ACTION = 'app/Menu/SELECT_OPTION_ACTION';
export const ACTIVE_MENU_ACTION = 'app/Menu/ACTIVE_MENU_ACTION';
